import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBooleanFeatureFlag } from "services/remoteconfig/useBooleanFeatureFlag";

import { getMetaPageRoute, setMetaPixelEnabled, trackMetaPageView } from "../services/meta/MetaPixel";

export default function MetaPageTracker(): null {
    const { pathname, search } = useLocation();
    const { enabled, status } = useBooleanFeatureFlag("publizm_meta_pixel_enabled");
    const active = status === "ready" && enabled;

    useEffect(() => {
        setMetaPixelEnabled(active);
        return () => setMetaPixelEnabled(false);
    }, [active]);

    useEffect(() => {
        trackMetaPageView(getMetaPageRoute(pathname, search));
    }, [active, pathname, search]);

    return null;
}
